import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.setDarkClass()
  }

  toggle() {
    localStorage.setItem("darkMode", !this.isEnabled)

    this.setDarkClass()
  }

  setDarkClass() {
    this.element.classList.toggle("dark", this.isEnabled)
  }

  get isEnabled() {
    return localStorage.getItem("darkMode") === "true"
  }
}
